import React, { useContext } from 'react';
import styles from './GeneralInformation.module.scss';
import { GeneralInformationValueType, ReportTags } from '../../../../Models';
import { formatDate } from '../../../../Helpers';
import { SFText } from 'sfui';
import { CustomerContext, Customer } from 'ui-smartforce-settings';
import { TagsInformation } from '../TagsInformation/TagsInformation';

export interface GeneralInformationProps {
  data: GeneralInformationValueType;
  tags: ReportTags | null | undefined;
}

export const GeneralInformation = ({
  data,
  tags
}: GeneralInformationProps): React.ReactElement<GeneralInformationProps> => {
  const timezone = (useContext(CustomerContext).customer as Customer).timezone;

  return (
    <div className={styles.generalInformation}>
      <div className={styles.infoItem}>
        <SFText type="component-messages" sfColor="neutral">
          OFFICER NAME
        </SFText>
        <SFText type="component-1">{data.officer_name as string}</SFText>
      </div>

      <div className={styles.infoItem}>
        <SFText type="component-messages" sfColor="neutral">
          DATE AND TIME
        </SFText>
        <SFText type="component-1">
          {formatDate(data.date as string, 'L - HH:mm', timezone)}
        </SFText>
      </div>

      {data.duration && (
        <div className={styles.infoItem}>
          <SFText type="component-messages" sfColor="neutral">
            DURATION IN MINUTES
          </SFText>
          <SFText type="component-1">{data.duration}</SFText>
        </div>
      )}

      {tags && tags.agency.length > 0 && <TagsInformation tags={tags} />}
    </div>
  );
};
